module.exports = __webpack_public_path__ + "img/18_40.82107419.png";